import React, { type PropsWithChildren } from 'react';
import { Platform, StyleSheet } from 'react-native';
import {
  SafeAreaView,
  useSafeAreaInsets,
} from 'react-native-safe-area-context';
import { useStyle } from 'react-native-style-utilities';
import { theme, useKeyboardAvoiderPadding, useResponsive } from '@sg/garnish';

export const SierraContainer = (props: PropsWithChildren) => {
  const { match } = useResponsive();
  const containerStyle = match([styles.containerXS, styles.containerSM]);

  const { top, bottom } = useSafeAreaInsets();

  const { keyboardPadding } = useKeyboardAvoiderPadding();
  const padding = useStyle(
    () => ({
      paddingTop: Platform.select({ android: top }), // iOS doesn't need it due to modal presentation.
      paddingBottom: keyboardPadding?.paddingBottom ?? 0,
    }),
    [bottom, keyboardPadding],
  );

  return (
    <SafeAreaView edges={['bottom']} style={[containerStyle, padding]}>
      {props.children}
    </SafeAreaView>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  containerXS: {
    flex: 1,
    zIndex: theme.zIndex.modal,
    backgroundColor: theme.colors.WHITE,
  },
  containerSM: {
    minWidth: 375,
    height: 625,
    position: 'absolute',
    bottom: theme.spacing['4'],
    right: theme.spacing['4'],
    zIndex: theme.zIndex.modal,
    backgroundColor: theme.colors.OPACITY.TRANSPARENT,
    borderRadius: theme.radius.medium,
    overflow: 'hidden',
    ...theme.elevations['2'],
  },
});
